import React, { FunctionComponent, ReactElement } from 'react'
import styled from 'styled-components'
import { ClickableProps, CommonProps, WebTaboolaRegionItemProps } from '../../styles/types'
import { clickable } from '../../styles'

const Clickable = styled.a<ClickableProps & { activeOpacity: number; expand?: boolean }>`
    text-decoration: none;
    display: flex;
    flex-direction: column;
    transition: 0s 0.1s;
    ${(props): string => {
        return props.expand ? 'width: 100%; height: 100%;' : ''
    }};

    :active {
        opacity: ${/* istanbul ignore next */ (props): string => `${props.activeOpacity}`};
        transition: 0s;
    }

    ${clickable}
`

export type HyperlinkProps = CommonProps &
    ClickableProps &
    WebTaboolaRegionItemProps & {
        onPress?: () => void
        onLongPress?: () => void
        href: string
        activeOpacity?: number
        expand?: boolean
        webRel?: (href?: string) => string | undefined
    }

const Hyperlink: FunctionComponent<HyperlinkProps> = ({
    children,
    href,
    onPress,
    onLongPress,
    activeOpacity = 0.2,
    expand,
    pointer = true,
    pointerEvents,
    webRel,
    testID,
    webTBRegionItem,
}): ReactElement => {
    return (
        <Clickable
            href={href}
            onClick={onPress}
            onContextMenu={onLongPress}
            activeOpacity={activeOpacity}
            expand={expand}
            pointer={pointer}
            pointerEvents={pointerEvents}
            data-testid={testID}
            data-tb-region-item={webTBRegionItem}
            rel={webRel?.(href)}
        >
            {children}
        </Clickable>
    )
}

export default Hyperlink
